import RedirectUrlTextField from "./redirectUrlTextField.container"

export default RedirectUrlTextField
